import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-blue-100">
      <Header />
      {/* Hero Section */}
      <div id="about" className="container mx-auto px-4 py-24 scroll-mt-20">
        <div className="text-center transition-all duration-800 ease-in-out">
          <h1 className="text-5xl font-bold text-blue-800 mb-9">
            Welcome to GigPayDay
          </h1>
          <p className="text-xl text-gray-700 mb-12 max-w-2xl mx-auto">
            The premier platform connecting employers with qualified contractors for temporary work assignments.
            Streamline your workforce management with GPS-verified work sessions and secure payments.
          </p>
          <div className="space-x-4">
            <Link
              to="/auth/login"
              className="bg-blue-600 text-white px-10 py-4 rounded-lg hover:bg-blue-700 transition-colors text-lg"
            >
              Get Started
            </Link>
            <Link
              to="/auth/register"
              className="bg-white text-blue-600 px-10 py-4 rounded-lg border border-blue-600 hover:bg-blue-50 transition-colors text-lg"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div id="payments" className="bg-white py-24 scroll-mt-20">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-blue-800 mb-16">
            Why Choose GigPayDay?
          </h2>
          <div className="grid md:grid-cols-3 gap-12">
            <div className="p-10 rounded-xl bg-blue-50 transition-all duration-500 hover:shadow-lg min-h-[200px] flex flex-col justify-center">
              <h3 className="text-xl font-semibold text-blue-700 mb-6">
                GPS-Verified Work
              </h3>
              <p className="text-gray-600 text-base leading-relaxed">
                Track work sessions with GPS check-in/check-out for accurate time tracking and location verification.
              </p>
            </div>
            <div className="p-10 rounded-xl bg-blue-50 transition-all duration-500 hover:shadow-lg min-h-[200px] flex flex-col justify-center">
              <h3 className="text-xl font-semibold text-blue-700 mb-6">
                Secure Payments
              </h3>
              <p className="text-gray-600 text-base leading-relaxed">
                Automated payment processing with multiple payment methods including credit card, bank transfer, and PayPal.
              </p>
            </div>
            <div className="p-10 rounded-xl bg-blue-50 transition-all duration-500 hover:shadow-lg min-h-[200px] flex flex-col justify-center">
              <h3 className="text-xl font-semibold text-blue-700 mb-6">
                Quality Matching
              </h3>
              <p className="text-gray-600 text-base leading-relaxed">
                Find the perfect match for your project needs with our specialized contractor matching system.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* User Types Section */}
      <div className="container mx-auto px-4 py-24">
        <h2 className="text-3xl font-bold text-center text-blue-800 mb-16">
          Join Our Platform
        </h2>
        <div className="grid md:grid-cols-3 gap-12">
          <div id="payers" className="text-center p-10 rounded-xl bg-white shadow-lg min-h-[260px] flex flex-col justify-between scroll-mt-24">
            <div>
              <h3 className="text-xl font-semibold text-blue-700 mb-6">For Employers</h3>
              <p className="text-gray-600 mb-6 text-base leading-relaxed">
                Post gigs, review applications, and monitor work progress with real-time GPS tracking.
              </p>
            </div>
            <Link
              to="/auth/register"
              className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-block"
            >
              Hire Contractors
            </Link>
          </div>
          <div id="workers" className="text-center p-10 rounded-xl bg-white shadow-lg min-h-[260px] flex flex-col justify-between scroll-mt-24">
            <div>
              <h3 className="text-xl font-semibold text-blue-700 mb-6">For Contractors</h3>
              <p className="text-gray-600 mb-6 text-base leading-relaxed">
                Apply for gigs, track your work sessions, and get paid securely through your preferred method.
              </p>
            </div>
            <Link
              to="/auth/register"
              className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-block"
            >
              Find Work
            </Link>
          </div>
          <div className="text-center p-10 rounded-xl bg-white shadow-lg min-h-[260px] flex flex-col justify-between">
            <div>
              <h3 className="text-xl font-semibold text-blue-700 mb-6">For Admins</h3>
              <p className="text-gray-600 mb-6 text-base leading-relaxed">
                Monitor platform activity, manage users, and access comprehensive analytics and reports.
              </p>
            </div>
            <Link
              to="/auth/login"
              className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-block"
            >
              Access Dashboard
            </Link>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-24">
        <div className="text-center transition-all duration-800 ease-in-out">
          <h2 className="text-3xl font-bold text-blue-800 mb-9">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-700 mb-12 max-w-2xl mx-auto">
            Join GigPayDay today and experience the future of temporary work management.
          </p>
          <div className="space-x-4">
            <Link
              to="/auth/register"
              className="bg-blue-600 text-white px-10 py-4 rounded-lg hover:bg-blue-700 transition-colors text-lg"
            >
              Sign Up Now
            </Link>
            <Link
              to="/auth/login"
              className="bg-white text-blue-600 px-10 py-4 rounded-lg border border-blue-600 hover:bg-blue-50 transition-colors text-lg"
            >
              Log In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 